import { Rule } from 'api/ml-service/ml-service.types';
import { useTranslation } from 'react-i18next';

export const useGetItemWordings = () => {
  const { t } = useTranslation();
  const orText = t('page.menus.recommendations.customRules.itemWordings.or');
  const andText = t('page.menus.recommendations.customRules.itemWordings.and');

  const getItemWordings = (list: string[], ruleType: Rule['ruleType']) => {
    const ruleTypeText = ruleType === 'OR' ? orText : andText;

    switch (list.length) {
      case 1:
        return list[0];
      case 2:
        return `${list[0]} ${ruleTypeText} ${list[1]}`;
      default:
        return `${list[0]}, ${list[1]} ${ruleTypeText} ${t(
          'page.menus.recommendations.customRules.itemWordings.other',
          {
            count: list.length - 2,
          },
        )}`;
    }
  };
  return { getItemWordings };
};
